<form
  *ngIf="enterPinFG"
  autocomplete="off"
  class="form digit-group"
  [class.mfa-pin-form]="mfa"
  #form="ngForm"
  [formGroup]="enterPinFG"
  (ngSubmit)="enterPin(form)"
>
  <div [hidden]="otpScreen">
    <div class="{{ mfa ? 'mfa-login' : 'pin-enter-screen' }} text-center m-auto">
      <p>
        <b>{{ translate.currentLang === 'en' ? 'Please enter a new PIN' : 'অনুগ্রহ করে একটি নতুন PIN লিখুন' }}</b>
      </p>
      <div formGroupName="pinCode" class="form-group">
        <input
          #pinInput
          formControlName="pin1"
          autocomplete="new-password"
          name="pin1"
          type="text"
          pattern="[0-9]*"
          tabindex="1"
          maxlength="1"
          (keydown)="restrictInput($event, 0)"
          (input)="validateInput($event, 0, 'pinCode', 'pin1')"
          (paste)="blockPaste($event)"
        />
        <input
          #pinInput
          formControlName="pin2"
          autocomplete="off"
          name="pin2"
          type="text"
          pattern="[0-9]*"
          tabindex="2"
          maxlength="1"
          (input)="validateInput($event, 1, 'pinCode', 'pin2')"
          (keydown)="restrictInput($event, 1)"
          (paste)="blockPaste($event)"
        />
        <input
          #pinInput
          formControlName="pin3"
          autocomplete="off"
          name="pin3"
          type="text"
          pattern="[0-9]*"
          tabindex="3"
          maxlength="1"
          (input)="validateInput($event, 2, 'pinCode', 'pin3')"
          (keydown)="restrictInput($event, 2)"
          (paste)="blockPaste($event)"
        />
        <input
          #pinInput
          formControlName="pin4"
          autocomplete="off"
          name="pin4"
          type="text"
          pattern="[0-9]*"
          tabindex="4"
          maxlength="1"
          (input)="validateInput($event, 3, 'pinCode', 'pin4')"
          (keydown)="restrictInput($event, 3)"
          (paste)="blockPaste($event)"
        />
        <input
          *ngIf="!mfa"
          #pinInput
          formControlName="pin5"
          autocomplete="off"
          name="pin5"
          type="text"
          pattern="[0-9]*"
          tabindex="5"
          maxlength="1"
          (input)="validateInput($event, 4, 'pinCode', 'pin5')"
          (keydown)="restrictInput($event, 4)"
          (paste)="blockPaste($event)"
        />
        <input
          *ngIf="!mfa"
          #pinInput
          formControlName="pin6"
          autocomplete="off"
          name="pin6"
          type="text"
          pattern="[0-9]*"
          tabindex="6"
          maxlength="1"
          (input)="validateInput($event, 5, 'pinCode', 'pin6')"
          (keydown)="restrictInput($event, 5)"
          (paste)="blockPaste($event)"
        />
        <div class="col-7 m-auto" *ngIf="!mfa">
          <errors
            [on]="
              ((enterPinFG.get('pinCode').get('pin1').touched || form.submitted) && enterPinFG.get('pinCode').get('pin1').invalid) ||
              ((enterPinFG.get('pinCode').get('pin2').touched || form.submitted) && enterPinFG.get('pinCode').get('pin2').invalid) ||
              ((enterPinFG.get('pinCode').get('pin3').touched || form.submitted) && enterPinFG.get('pinCode').get('pin3').invalid) ||
              ((enterPinFG.get('pinCode').get('pin4').touched || form.submitted) && enterPinFG.get('pinCode').get('pin4').invalid) ||
              ((enterPinFG.get('pinCode').get('pin5').touched || form.submitted) && enterPinFG.get('pinCode').get('pin5').invalid) ||
              ((enterPinFG.get('pinCode').get('pin6').touched || form.submitted) && enterPinFG.get('pinCode').get('pin6').invalid)
            "
          >
            {{ translate.currentLang === 'en' ? 'Required' : 'আবশ্যক' }}
          </errors>
        </div>
        <div class="col-7 m-auto" *ngIf="mfa">
          <errors
            [on]="
              ((enterPinFG.get('pinCode').get('pin1').touched || form.submitted) && enterPinFG.get('pinCode').get('pin1').invalid) ||
              ((enterPinFG.get('pinCode').get('pin2').touched || form.submitted) && enterPinFG.get('pinCode').get('pin2').invalid) ||
              ((enterPinFG.get('pinCode').get('pin3').touched || form.submitted) && enterPinFG.get('pinCode').get('pin3').invalid) ||
              ((enterPinFG.get('pinCode').get('pin4').touched || form.submitted) && enterPinFG.get('pinCode').get('pin4').invalid)
            "
          >
            {{ translate.currentLang === 'en' ? 'Required' : 'আবশ্যক' }}
          </errors>
        </div>
      </div>
      <p>
        <b>{{ translate.currentLang === 'en' ? 'Re-enter your PIN' : 'আপনার PIN পুনরায় লিখুন' }}</b>
      </p>
      <div formGroupName="confirmPinCode" class="form-group">
        <input
          #pinInput
          formControlName="pin1"
          [ngClass]="
            enterPinFG.get('pinCode').get('pin1').value &&
            enterPinFG.get('confirmPinCode').get('pin1').value &&
            enterPinFG.get('pinCode').get('pin1').value !== enterPinFG.get('confirmPinCode').get('pin1').value
              ? 'invalid'
              : 'valid'
          "
          autocomplete="off"
          name="pin1"
          type="text"
          pattern="[0-9]*"
          tabindex="7"
          maxlength="1"
          (input)="validateInput($event, mfa ? 4 : 6, 'confirmPinCode', 'pin1')"
          (keydown)="restrictInput($event, mfa ? 4 : 6)"
          (paste)="blockPaste($event)"
        />
        <input
          #pinInput
          formControlName="pin2"
          autocomplete="off"
          name="pin2"
          type="text"
          pattern="[0-9]*"
          tabindex="8"
          maxlength="1"
          (input)="validateInput($event, mfa ? 5 : 7, 'confirmPinCode', 'pin2')"
          [ngClass]="
            enterPinFG.get('pinCode').get('pin2').value &&
            enterPinFG.get('confirmPinCode').get('pin2').value &&
            enterPinFG.get('pinCode').get('pin2').value !== enterPinFG.get('confirmPinCode').get('pin2').value
              ? 'invalid'
              : 'valid'
          "
          (keydown)="restrictInput($event, mfa ? 5 : 7)"
          (paste)="blockPaste($event)"
        />
        <input
          #pinInput
          formControlName="pin3"
          autocomplete="off"
          name="pin3"
          type="text"
          pattern="[0-9]*"
          tabindex="9"
          maxlength="1"
          (input)="validateInput($event, mfa ? 6 : 8, 'confirmPinCode', 'pin3')"
          [ngClass]="
            enterPinFG.get('pinCode').get('pin3').value &&
            enterPinFG.get('confirmPinCode').get('pin3').value &&
            enterPinFG.get('pinCode').get('pin3').value !== enterPinFG.get('confirmPinCode').get('pin3').value
              ? 'invalid'
              : 'valid'
          "
          (keydown)="restrictInput($event, mfa ? 6 : 8)"
          (paste)="blockPaste($event)"
        />
        <input
          #pinInput
          formControlName="pin4"
          autocomplete="off"
          name="pin4"
          type="text"
          pattern="[0-9]*"
          tabindex="10"
          maxlength="1"
          (input)="validateInput($event, mfa ? 7 : 9, 'confirmPinCode', 'pin4')"
          [ngClass]="
            enterPinFG.get('pinCode').get('pin4').value &&
            enterPinFG.get('confirmPinCode').get('pin4').value &&
            enterPinFG.get('pinCode').get('pin4').value !== enterPinFG.get('confirmPinCode').get('pin4').value
              ? 'invalid'
              : 'valid'
          "
          (keydown)="restrictInput($event, mfa ? 7 : 9)"
          (paste)="blockPaste($event)"
        />
        <input
          *ngIf="!mfa"
          #pinInput
          formControlName="pin5"
          autocomplete="off"
          name="pin5"
          type="text"
          pattern="[0-9]*"
          tabindex="11"
          maxlength="1"
          (input)="validateInput($event, 10, 'confirmPinCode', 'pin5')"
          [ngClass]="
            enterPinFG.get('pinCode').get('pin5').value &&
            enterPinFG.get('confirmPinCode').get('pin5').value &&
            enterPinFG.get('pinCode').get('pin5').value !== enterPinFG.get('confirmPinCode').get('pin5').value
              ? 'invalid'
              : 'valid'
          "
          (keydown)="restrictInput($event, 10)"
          (paste)="blockPaste($event)"
        />
        <input
          *ngIf="!mfa"
          #pinInput
          formControlName="pin6"
          autocomplete="off"
          name="pin6"
          type="text"
          pattern="[0-9]*"
          tabindex="12"
          maxlength="1"
          (input)="validateInput($event, 11, 'confirmPinCode', 'pin6')"
          [ngClass]="
            enterPinFG.get('pinCode').get('pin6').value &&
            enterPinFG.get('confirmPinCode').get('pin6').value &&
            enterPinFG.get('pinCode').get('pin6').value !== enterPinFG.get('confirmPinCode').get('pin6').value
              ? 'invalid'
              : 'valid'
          "
          (keydown)="restrictInput($event, 11)"
          (paste)="blockPaste($event)"
        />
      </div>
      <div class="row">
        <div class="col-auto m-auto" [hidden]="!pinMismatchError">
          <div class="aler alert-danger">{{ translate.currentLang === 'en' ? 'PIN does not match' : 'PIN মিলছে না' }}</div>
        </div>
        <div class="col-auto m-auto" [hidden]="!weakPin">
          <div class="aler alert-danger">
            {{
              translate.currentLang === 'en'
                ? 'Weak PIN pattern. Please choose a
            different PIN.'
                : 'দুর্বল PIN প্যাটার্ন। অনুগ্রহ করে একটি ভিন্ন PIN বেছে নিন।'
            }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8 m-auto mt-2">
        <button type="submit" class="btn btn-primary m-auto">
          {{ translate.currentLang === 'en' ? 'Set PIN & Continue' : 'PIN সেট করুন এবং চালিয়ে যান' }}
        </button>
      </div>
      <div class="col-12 col-md-8 m-auto mt-2">
        <button type="button" class="btn global-gray-button m-auto" (click)="setupLater()">
          {{ translate.currentLang === 'en' ? 'Setup later' : 'পরে সেটআপ করুন' }}
        </button>
      </div>
    </div>
  </div>
</form>
